/*
 * Поповер для баланса
 * Наследуется от Marionette.LayoutView
 * author Aleksander Vasilenko <info@acset.ru>
 * @2015
 */

define(function(require){
    'use strict';

    var _ = require('underscore');
    var Marionette  = require('marionette');
    var BasePopover = require('popovers/_base/view');

    var BodyTPL   = require('text!popovers/balance/templates/body.tpl').default;
    var HeaderTPL = require('text!popovers/balance/templates/header.tpl').default;
    var HeaderView = Marionette.ItemView.extend({ template : HeaderTPL });
    var BodyView   = Marionette.ItemView.extend({ template : BodyTPL });
    var ModalsFactory   = require('modals/factory');

    return BasePopover.extend({

        events : {
            'click .js-close'  : 'hide',
            'click .js-add_funds': 'onClickAddFunds',
            'click .js-activate-tariff': 'activateTariff',
            'click .js-activate-package': 'activatePackage'
        },

        onShow : function(){
            this.$el.lptSetter();
        },

        onBeforeRender : function(){
            const tariffPackage = app.Models.Account.get('tariff_package') || {};
            const tariffPackageDateTill = tariffPackage.date_end ? app.Utils.moment(tariffPackage.date_end).format('DD.MM.YYYY HH:mm'):false;

            const voicebotPackage = app.Models.Account.get('voicebot_package') || {};
            const voicebotPackageDateTill = voicebotPackage.date_end ? app.Utils.moment(voicebotPackage.date_end).format('DD.MM.YYYY HH:mm'):false;

            const noAutoRaiseTariff = app.Models.Account.get('no_auto_raise_tariff');
            const product = app.Models.User.get('product');
            const showCurrentTariff = !product || product.options.current_tariff;
            const showTodayTraffic = !noAutoRaiseTariff && (!product || product.options.today_traffic);
            const showSiteCount = !product || product.options.sites_count;
            const showPrice = !product || product.options.price;
            const showTariffManagmentBtn = !product || product.options.tariff_management;
            const showBalanceDetailBtn = !product || product.options.balance_detailing;
            const showTopupBalanceBtn = !product || product.options.topup_balance;
            const paymentUrl = !product || product.options.payment_url;
            const options = {
                popover_id  : 'b-popover__balance',
                placement   : 'auto-bottom',
                title       : '',
                width       : 340,
                // show_header : !app.Models.Account.get('useTariffCalculator'),
                show_footer : false,
                zIndex      : 99999,
                dateTill    : tariffPackageDateTill,
                tariffPackageAvailable: tariffPackage.package_available,
                tariffPackageActive: tariffPackage.is_active,
                voicebotDateTill    : voicebotPackageDateTill,
                voicebotMinutesLeft    : Math.round(voicebotPackage.minutes) || 0,
                voicebotPackageAvailable: voicebotPackage.package_available,
                voicebotPackageActive: voicebotPackage.is_active,
                showCall    : true,//call.is_visible && callValue.value > 0,
                showSms     : true,//sms.is_visible && smsValue.value > 0,
                showTodayTraffic,
                showCurrentTariff,
                showSiteCount,
                showPrice,
                showTariffManagmentBtn,
                showBalanceDetailBtn,
                showTopupBalanceBtn,
                paymentUrl,
            };

            _.extend(options, app.Models.Account.toJSON());

            this.model.set(options);
            this.model.set('employees_total', this.model.get('employees_total'));
            this.model.set('sites_total', this.model.get('sites_total'));
        } ,

        showHeader: function(){
            const product = app.Models.User.get('product');
            const allowDailyBilling = app.Models.Account.get('allow_daily_billing');
            const tariffPackage = app.Models.Account.get('tariff_package') || {};

            if (!tariffPackage.is_active && (!product || product.options.balance_days_left) && allowDailyBilling) {
                this.regionHeader.show(new HeaderView({model: this.model}));
            }
        },

        showBody: function () {
            if (app.Views.Header.rightSidebarOpen) app.Views.Header.hideRightSidebar();
            this.regionBody.show( new BodyView({ model: this.model }) );
        },

        onClickAddFunds: function() {
            this.showAddFunds();
        },

        showAddFunds: function(sum) {
          if(app.Models.Account.get('tariff_selected')
                    && app.Models.Account.get('tariff_id') == 11186
                    && app.Models.User.get('product')
                    && app.Models.User.get('product').options['force_tariff_select']
                    && location.hash.indexOf('#tariffs') === -1
                    ) {
                        return ModalsFactory.create('selectTariff', function (RenewalModal) {
                            app.regionHeader.currentView.triggerMethod('showModal', new RenewalModal({
                            modalData: {'caption':"Аккаунт заблокирован! \n Для продолжения работы активируйте пакет абонентской платы"}
                        }))});
                    }
            const tariffPackage = app.Models.Account.get('tariff_package');

            sum = sum || 931;
            this.hide();

            if(!app.Models.Account.isTariffSelected() && app.Models.User.get('product').options['force_tariff_select'] && location.hash.indexOf('#tariffs') === -1) {
              ModalsFactory.create('selectTariff', function (RenewalModal) {
                this.triggerMethod('showModal', new RenewalModal({
                  modalData: {}
                }));
              }.bind(this));
              return;
            }

            if (tariffPackage && tariffPackage.package_available) {
                ModalsFactory.create('renewal', function (RenewalModal) {
                    this.triggerMethod('showModal', new RenewalModal({
                        modalData: {}
                    }));
                }.bind(this));
            } else {
                ModalsFactory.create('add_funds', function(AddFundsModal) {
                  this.triggerMethod('showModal', new AddFundsModal({
                    modalData: {
                      paySumm: sum//this.model.get('payment_month')
                    }
                  }));
                }.bind(this));
            }
        },

        // activateTariff: function() {
        //     ModalsFactory.create('activate_tariff', function (Modal) {
        //         var modal = new Modal({
        //             modalData: {
        //                 modules: app.Models.Tariff.get('modules'),
        //                 price: app.Models.Tariff.get('price')
        //             }
        //         });

        //         this.listenTo(modal, 'tariffActivated', function (packageId) {
        //             var that = this;
        //             var modules = app.Models.Tariff.get('modules');
        //             var duration = modules.find({name: 'duration'});
        //             var sms = modules.find({name: 'sms'});
        //             var call = modules.find({name: 'call'});

        //             if (duration) {
        //                 duration.set('value', packageId);
        //             }
        //             sms.set('value', 0);
        //             call.set('value', 0);
        //             //app.Models.Tariff.set('modules', modules.concat());
        //             app.Models.Tariff.unset('id');
        //             app.Models.Tariff.unset('full_price');
        //             app.Models.Tariff
        //                 .save()
        //                 .then(function(resolve, statusText, xhr) {
        //                     var balance = app.Models.Account.get('balance');
        //                     var response = xhr.responseJSON || {};
        //                     var sum = 931;
        //                     var message;

        //                     if (xhr.status == 202) {
        //                         if (response && response.connection_price) {
        //                             sum = Math.ceil(response.connection_price - balance);
        //                         }
        //                         message = app.message.error('Для активации выбранных услуг на балансе не хватает ' + sum + ' руб.<br/><a href="javascript:void(0)" style="color: var(--main-btn-color)">Пополнить баланс</a>');
        //                         message.$el.find('a').click(function() {
        //                             that.showAddFunds(sum, sum);
        //                         });
        //                     } else {
        //                         ModalsFactory.create('tariffActivated', function(Modal) {
        //                             app.regionModal.show(new Modal({
        //                                 preventOverlayClick: true,
        //                                 closeOnEsc: false,
        //                                 modalData: {
        //                                     dateTill: app.Models.Tariff.get('will_be_active_till')*1000
        //                                 }
        //                             }));
        //                         }.bind(this));
        //                         duration.set('value', 0);
        //                     }
        //                 })
        //         });

        //         this.triggerMethod('showModal', modal);
        //     }.bind(this));
        // },

        activatePackage: function(event) {
            if(!app.Models.Account.isTariffSelected() && app.Models.User.get('product').options['force_tariff_select'] && location.hash.indexOf('#tariffs') === -1) {
              ModalsFactory.create('selectTariff', function (RenewalModal) {
                this.triggerMethod('showModal', new RenewalModal({
                  modalData: {}
                }));
              }.bind(this));
              return;
            }

            ModalsFactory.create('renewal', function (RenewalModal) {
                this.triggerMethod('showModal', new RenewalModal({
                    modalData: {}
                }));
            }.bind(this));
        }
    });

 });
